import scheduleFiveElements, { getScheduleFiveGridEntries } from './schedule-five-elements';
import scheduleFive from './schedule-five';
import scheduleFiveNotRequired from './schedule-five-not-required';
import setupMonthSelect from './schedule-five-month-select';
import gridExport from '../../global/grid-export';
import { exportSummaryToExcel } from '../../operations/schedule-five/schedule-five-overview/schedule-five-summary-export';

export default function(nameAction, namePage) {
    scheduleFiveElements();
    setupMonthSelect();

    const ddl = gridExport('.js-export-select', () => null, onExport);
    if (ddl) {
        ddl.dataSource.data([{ text: 'Excel', value: 1 }]);
    }

    if (namePage === 'schedulefive') scheduleFive();
    if (namePage === 'schedulefivenotrequired') scheduleFiveNotRequired();
}

const onExport = () => {
    const now = new Date();
    const stamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
    // Project numbers are stored as "1800051.", strip period numbers to not contain extra dots before the file extension.
    const projectNumber = ($('[name=projectNumber]').val() || '').replace(/\./g, '');
    const fileName = ['ScheduleFive', projectNumber, stamp].filter(Boolean).join('_');
    exportSummaryToExcel(getScheduleFiveGridEntries(), `${fileName}.xlsx`);
};
